import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const PhoneIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 22.113 22.099"
    >
      <g transform="translate(1.012 1.099)">
        <path
          d="M1111.072,82.929l-4.048-2.7a1.181,1.181,0,0,0-1.582.257L1104.263,82a.5.5,0,0,1-.647.136l-.224-.123a13.581,13.581,0,0,1-3.533-2.775,13.638,13.638,0,0,1-2.775-3.533l-.123-.224a.506.506,0,0,1,.134-.649l1.515-1.179a1.181,1.181,0,0,0,.257-1.582l-2.7-4.049a1.174,1.174,0,0,0-1.584-.356l-1.693,1.017A2.386,2.386,0,0,0,1091.8,70.1c-.609,2.221-.151,6.054,5.5,11.7,4.492,4.492,7.836,5.7,10.134,5.7a5.911,5.911,0,0,0,1.566-.205,2.388,2.388,0,0,0,1.414-1.089l1.017-1.692A1.174,1.174,0,0,0,1111.072,82.929Z"
          transform="translate(-1091.597 -67.5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
